<div class="nav-shell" [class.nav-shell--mobile-nav-open]="mobileNavOpen">
  <div class="nav-primary">
    <div class="nav-primary__inner">
      <ng-container *ngIf="{ isDark: (theme.isDark$ | async) ?? false } as themeVm">
        <button
          type="button"
          class="mobile-nav-menu-btn"
          tid="mobile-nav-menu"
          (click)="toggleMobileNav()"
          [attr.aria-expanded]="mobileNavOpen"
          aria-controls="primary-app-navigation"
          aria-label="Toggle application navigation"
        >
          <app-icon [size]="'small'" [color]="themeVm.isDark ? 'white' : 'primary-action'">{{
            mobileNavOpen ? 'close' : 'menu'
          }}</app-icon>
        </button>
      </ng-container>

      <div class="nav-primary__trail" *ngIf="displayBreadcrumb$ | async as bc">
        <nav *ngIf="bc.section || bc.page" class="nav-breadcrumb" aria-label="Breadcrumb">
          <ng-container *ngIf="bc.page; else sectionOnlyCrumb">
            <app-body class="nav-breadcrumb__section" [bold]="true" [ink]="'ink-100'">{{ bc.section }}</app-body>
            <span class="nav-breadcrumb__sep" aria-hidden="true">/</span>
            <app-body class="nav-breadcrumb__page" [ink]="'ink-70'">{{ bc.page }}</app-body>
          </ng-container>
          <ng-template #sectionOnlyCrumb>
            <app-body class="nav-breadcrumb__section" [bold]="true" [ink]="'ink-100'">{{ bc.section }}</app-body>
          </ng-template>
        </nav>
      </div>

      <div class="side-nav">
        <ng-container *ngIf="{ isDark: (theme.isDark$ | async) ?? false } as vm">
          <button
            type="button"
            class="theme-toggle"
            tid="theme-toggle"
            (click)="toggleDarkMode()"
            [attr.aria-label]="vm.isDark ? 'Switch to light mode' : 'Switch to dark mode'"
            [attr.aria-pressed]="vm.isDark"
          >
            <app-icon [size]="'small'" [color]="vm.isDark ? 'white' : 'primary-action'">{{
              vm.isDark ? 'light_mode' : 'dark_mode'
            }}</app-icon>
          </button>
        </ng-container>
        <app-user-menu class="user-action-menu"></app-user-menu>
      </div>
    </div>
  </div>

  <div class="nav-body">
    <aside id="primary-app-navigation" class="sub-nav-panel" aria-label="Application navigation">
      <div class="sub-nav-panel__brand">
        <app-unity-brand-lockup
          linkTo="/"
          tid="unity-home-link"
          anchorCssClass="sub-nav-panel__brand-link"
        />
      </div>

      <nav class="main-nav-tree" *ngIf="mainNavDrawerRoutes$ | async as routes">
        <ng-container *ngIf="activeItem$ | async as activeTitle">
          <div *ngFor="let route of routes" class="main-nav-tree__section">
            <app-nav-tree-section
              [route]="route"
              [activeTitle]="activeTitle"
              [expandedTitles]="expandedSectionTitles"
              (toggle)="toggleSection($event)"
            />
          </div>
        </ng-container>
      </nav>
    </aside>

    <div
      *ngIf="mobileNavOpen"
      class="nav-mobile-backdrop"
      (click)="closeMobileNav()"
      aria-hidden="true"
    ></div>

    <div class="nav-outlet">
      <ng-content></ng-content>
    </div>
  </div>
</div>
